export let option = {
	getText: (options, val) => {
		let item = options.find((v) => { return v.value === val; });
		return item ? item.text : '';
	},
	// 采购区域
	option_is_overseas: [
	  { value: '1', text: '境内' },
	  { value: '2', text: '境外' },
	],
	
	// 货源标识
	isep: [
	  { value: '1', text: 'EP货源' },
	  { value: '2', text: '非EP货源' },
	],
	
	// 是否需要开发票
	isinvoice: [
	  { value: '0', text: '需要' },
	  { value: '1', text: '不需要' },
	],
	
	// 付款条件
	paymentterms: [
	  { value: '0', text: '合同签订1日内付清' },
	  { value: '1', text: '货到3个工作日内' },
	  { value: '2', text: '货到30天' },
	],
	
	// 付款方式
	paytype: [
	  { value: '0', text: '银行转账' },
	  { value: '1', text: '微信支付' },
	  { value: '2', text: '支付宝支付' },
	  { value: '3', text: '现金支付' },
	  { value: '4', text: '支票' },
	  { value: '5', text: 'PayPal' },
	  { value: '6', text: '其他' },
	],
	
	// 结算方式
	settlementtype: [
	  { value: '0', text: '月结' },
	  { value: '1', text: '货到付款' },
	  { value: '2', text: '预付款+尾款' },
	  { value: '3', text: '预付全款' },
	  { value: '4', text: '其他' },
	  { value: '5', text: '货到7天内付款' },
	  { value: '6', text: '货到15天内付款' },
	  { value: '7', text: '货到30天内付款' },
	  { value: '8', text: '货到60天内付款' },
	  { value: '9', text: '月结30天' },
	  { value: '10', text: '月结45天' },
	  { value: '11', text: '月结60天' },
	  { value: '12', text: '货到3天内付款' },
	  { value: '13', text: '货到5天内付款' },
	  { value: '14', text: '月结1天' },
	  { value: '15', text: '月结5天' },
	  { value: '16', text: '月结15天' },
	  { value: '17', text: '月结60天' },
	],
	
	// 结算方式
	shippingmethods: [
	  { value: '0', text: '自提' },
	  { value: '1', text: '快递' },
	  { value: '2', text: '包车' },
	  { value: '3', text: '海运' },
	  { value: '4', text: '空运' },
	  { value: '5', text: '其他' },
	  { value: '6', text: '货拉拉' },
	],
	
	// 送货方式
	deliverymethods: [
		{ value: '1', text: '客户自提' },
		{ value: '2', text: '公司送货' },
	],
	
	// 运输方式
	transtype: [
		{ value: '1', text: '陆运' },
		{ value: '2', text: '空运' },
	],
	
	
	// 税率
	tax_rates: [ '0','1','3','6','13' ].map((item) => { return {text: item + '%', value: item} }),
	
	payment_corporation_type: [
		{ value: 1, text: '私账' },
		{ value: 2, text: '公账' },
	],
	
	intention_type: [
		{ value: '1', text: '对单' },
		{ value: '2', text: '备货' },
	],
	
	// 紧急程度
	degree: [
		{ value: '1', text: '普通' },
		{ value: '2', text: '紧急' },
	],
	
	deliveryplace_info_name: [
		{ value: 'HK办公室地址', text: 'HK办公室地址' },
		{ value: '飞力达地址', text: '飞力达地址' },
		{ value: '深圳1416仓库', text: '深圳1416仓库' },
		{ value: '深圳2706仓库', text: '深圳2706仓库' },
		{ value: '其他', text: '其他' },
	],
	
	customer_type: [
		{ value: 1, text: '渠道客户' },
		{ value: 2, text: '终端客户' },
	],
	
	transfer_type: [
		{ value: 1, text: 'HK--->SZ' },
		{ value: 2, text: 'HK--->HK' },
		{ value: 3, text: 'SZ--->HK' },
		{ value: 4, text: 'SZ--->SZ' },
	],
	
	inventorylog_type: [
		{ value: '0', text: '采购入库' },
		{ value: '7', text: '转仓出库' },
		{ value: '8', text: '转仓入库' },
		{ value: '9', text: '销售出库' },
		{ value: '20', text: '盘点异常入库' },
		{ value: '21', text: '盘点异常出库' },
		{ value: '25', text: '售后工单入库' },
		{ value: '26', text: '售后工单出库' },
		{ value: '27', text: '转仓驳回入库' },
		{ value: '28', text: '特殊入库' },
		{ value: '29', text: '特殊出库' },
		{ value: '30', text: '移库出库' },
		{ value: '31', text: '移库入库' },
		{ value: '34', text: '冻结' },
		{ value: '35', text: '解冻' },
		{ value: '36', text: '采购退换货出库' },
		{ value: '37', text: '采购换货入库' },
		{ value: '38', text: '销售驳回入库' },
		{ value: '39', text: '合并库位-出库' },
		{ value: '40', text: '合并库位-入库' },
		{ value: '43', text: '样品出库' },
		{ value: '44', text: '样品入库' },
		{ value: '48', text: '不良品出库' },
	],
	
	// 获取公司
	getCompanyList: async (obj, params) => {
	  let res = await obj.$post(obj.$api.stCompanyList, { page: params.page, name: params.query });
	  return res.data.list ? res.data.list.map( (item) => { return { text: item.name, value: item.id } } ) : [];
	},
	
	// 获取付款账户
	getCorporation: async (obj, params) => {
	  let res = await obj.$post(obj.$api.stCorporation, { page: params.page, name: params.query, custom_params: obj.customParams });
	  return res.data.list ? res.data.list.map( (item) => { return { text: item.name, value: item.id } } ) : [];
	},
	
	// 获取采购人员
	getUserList: async (obj, params) => {
	  let res = await obj.$post(obj.$api.stPurchaseUser, { page: params.page, nick_name: params.query, custom_params: obj.customParams });
	  return res.data ? res.data.map( (item) => { return { text: item.nickname, value: item.id } } ) : [];
	},
	
	// 获取供应商
	getSupplier: async (obj, params) => {
	  let res = await obj.$post(obj.$api.stPurchaseSupplier, { page: params.page, name: params.query, ...obj.customParams });
	  return res.data.list ? res.data.list.map( (item) => { return { text: item.name, value: item.id } } ) : [];
	},
	
	// 获取用户
	getAdmins: async (obj, params) => {
	  let res = await obj.$post(obj.$api.admins, { page: params.page, nickname: params.query, ...obj.customParams  });
	  return res.data.list ? res.data.list.map( (item) => { return { text: item.nickname, value: item.id } } ) : [];
	},
	
	// 产品类别
	getCategorys: async (obj, params) => {
	  let res = await obj.$post(obj.$api.categorySelect, { page: params.page, name: params.query, ...obj.customParams  });
	  return res.data.list ? res.data.list.map( (item) => { return { text: item.name, value: item.id } } ) : [];
	},
	
	// 获取物流商
	getExpress: async (obj, params) => {
	  let res = await obj.$post(obj.$api.stExpressSelect, { page: params.page, name: params.query, ...obj.customParams  });
	  return res.data.list ? res.data.list.map( (item) => { return { text: item.name, value: item.id } } ) : [];
	},
	
	// 获取币种
	getCurrency: async (obj, params) => {
	  let res = await obj.$post(obj.$api.stCurrency, { page: params.page, currency_name: params.query });
	  return res.data.list ? res.data.list.map( (item) => { return { text: item.tcur, value: item.tcur } } ) : [];
	},
	
	// 采购单产品
	getPurchaseSku: async (obj, params) => {
	  let res = await obj.$post(obj.$api.stPurchaseSku, { page: params.page, sku: params.query });
	  return res.data.list ? res.data.list.map( (item) => { return { text: item.sku, value: item.id } } ) : [];
	},
	
	// 仓库
	getWarehouse: async (obj, params) => {
	  let res = await obj.$post(obj.$api.stWarehouse, { page: params.page, name: params.query });
	  return res.data.list ? res.data.list.map( (item) => { return { text: item.name, value: item.id } } ) : [];
	},
	
	// 获取客户
	getCustomer: async (obj, params) => {
	  let res = await obj.$post(obj.$api.stCustomer, { page: params.page, customer_name: params.query });
	  return res.data.list ? res.data.list.map( (item) => { return { text: item.name, value: item.id } } ) : [];
	},
	
	// 境内付款条件
	getPayCondition1: async (obj, params) => {
	  let res = await obj.$post(obj.$api.stGetPayCondition + 1, { page: params.page, customer_name: params.query });
	  return res.data.list ? res.data.list.map( (item) => { return { text: item.text, value: item.value } } ) : [];
	},
	
	// 境外付款条件
	getPayCondition2: async (obj, params) => {
	  let res = await obj.$post(obj.$api.stGetPayCondition + 2, { page: params.page, customer_name: params.query });
	  return res.data.list ? res.data.list.map( (item) => { return { text: item.text, value: item.value } } ) : [];
	},
	
	// 尾款结算
	getTailType: async (obj, params) => {
		if (params.page > 1) return [];
	  let res = await obj.$post(obj.$api.stGetPurchaseFiledConf + 'tail_type', { page: params.page, customer_name: params.query });
	  return res.data.list ? res.data.list.map( (item) => { return { text: item.text, value: item.value } } ) : [];
	},
	
	// 获取采购单
	getPurchaseOrder: async (obj, params) => {
	  let res = await obj.$post(obj.$api.stGetCaigouSelect, { page: params.page, order_code: params.query });
	  return res.data.list ? res.data.list.map( (item) => { return { text: item.code, value: (obj.valField ? item[obj.valField] : item.id) } } ) : [];
	},
	
	// 获取销售单
	getSalesOrder: async (obj, params) => {
	  let res = await obj.$post(obj.$api.stGetXiaoshouSelect, { page: params.page, order_code: params.query });
	  return res.data.list ? res.data.list.map( (item) => { return { text: item.ordercode, value: (obj.valField ? item[obj.valField] : item.id) } } ) : [];
	},
	
	// 获取采购售后退货单
	getPurOrderReturn: async (obj, params) => {
	  let res = await obj.$post(obj.$api.stPurOrderReturnSelect, { page: params.page, code: params.query });
	  return res.data.list ? res.data.list.map( (item) => { return { text: item.code, value: (obj.valField ? item[obj.valField] : item.id) } } ) : [];
	},
	
	// 获取采购人员
	getInventorySkuList: async (obj, params) => {
	  let res = await obj.$post(obj.$api.stGetInventorySkus, { page: params.page, sku: params.query, custom_params: obj.customParams });
	  return res.data.list ? res.data.list.map( (item) => { return { text: item.products.sku + `(库存:${item.stocknum}不良:${item.rejectstocknum}冻结:${item.lockstocknum})`, value: item.id } } ) : [];
	},
	
	// 获取库存流水
	getInventoryLog: async (obj, params) => {
		let query = { 
			pageNumber: params.page,
			q_word: [params.query],
			pageSize: 10,
			andOr: 'OR',
			searchTable: 'tbl',
			showField: 'ordercode',
			keyField: 'id',
			searchField: ['ordercode'],
			ordercode: params['ordercode'],
			custom: params.custom,
			custom_params: obj.customParams
			// {
			// 	'products_id': params['products_id'],
			// 	'divergence': 1,
			// 	'customer': params['customer']
			// },
		};
	  let res = await obj.$post(obj.$api.stInventoryLogSelect, query);
	  return res.data.list ? res.data.list.map( (item) => { return { text: item.ordercode, value: item.id } } ) : [];
	},
	
	// 退货换货单
	getRmaOrder: async (obj, params) => {
	  let res = await obj.$post(obj.$api.selectRmaOrder, { page: params.page, code: params.query });
	  return res.data.list ? res.data.list.map( (item) => { return { text: item.code, value: (obj.valField ? item[obj.valField] : item.id) } } ) : [];
	},

	
	// 类里面的配置
	getModelConf: (model, conf) => {
		return async (obj, params) => {
			if (params.page > 1) 	return [];
			let res = await obj.$post(obj.$api.getModelConf, { page: params.page, mod: model, conf: conf });
			return res.data ? res.data : [];
		};
	},
	
	
	// 获取CRM币种
	getCrmCurrency: async (obj, params) => {
	  let res = await obj.$post(obj.$api.stCrmOptions, { page: params.page, type: 'currency' });
	  return res.data ? res.data.map( (item) => { return { text: item.text, value: item.value } } ) : [];
	},
	
	// 获取CRM DC
	getCrmDc: async (obj, params) => {
	  let res = await obj.$post(obj.$api.stCrmOptions, { page: params.page, type: 'dc' });
	  return res.data ? res.data.map( (item) => { return { text: item.text, value: item.value } } ) : [];
	},
	
	// 获取CRM 交期
	getCrmSubmitDay: async (obj, params) => {
	  let res = await obj.$post(obj.$api.stCrmOptions, { page: params.page, type: 'submitDay' });
	  return res.data ? res.data.map( (item) => { return { text: item.text, value: item.value } } ) : [];
	},
}

